import { useSession } from "contexts";
import { ReactNode, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { OrgTypes } from "utils/orgTypes";
import IntercomChat from "components/IntercomChat/IntercomChat";
import { useQuery } from "@apollo/client";
import { GetOrganizationBillingDocument, GetOrganizationBillingInfoDocument } from "graphql/generated";
import { AbilityContext } from "contexts/AbilityContext";
import { doesContatinSubjects } from "utils/PermissionHandler";
import Walkthrough from "views/Part91/Walkthrough";

export default function Part91Layout({ children }: { children: ReactNode }) { 
  const { user, organizationType, organizationId, logout } = useSession();  
  const navigate = useNavigate();
  const location = useLocation();
  const { data: { organizationAuth } = {}, error } = useQuery(GetOrganizationBillingDocument, {
    variables: { id: organizationId }, pollInterval: 50000
  });
  const ability = useContext(AbilityContext);
  // Check if the organization is cancelled
  useEffect(() => {
    if (organizationAuth?.cbInfo?.cb_status === 'cancelled' || organizationAuth?.cbInfo?.cb_status === 'paused') {
      if(doesContatinSubjects({ action:'PART91', subjects:['Admin'], ability}) && !window.location.href.includes('/account/settings?settingsTab=Billing')){
        navigate('/account/settings?settingsTab=Billing');
      }else if(!doesContatinSubjects({ action:'PART91', subjects:['Admin'], ability})) {
        navigate('/org-picker?cancelled=true');
      }
    }
  }, [organizationAuth, location]);

  //Check if user is logged in
  useEffect(() => {
    if (!user) {
      navigate('/auth');
    }

    if(organizationType === OrgTypes.PART145){ //kick out any users who are under 145
      navigate('/mro/dashboard');
    }
  }, [user, navigate]);

  useEffect(() => {
    if(error?.message == "Unauthorized") {
      logout();
      window.location.replace(window.location.origin+"/auth");
    }
  }, [error, navigate]);

  return (
    <>
      <Walkthrough>
        <Sidebar>
          <main className="flex flex-col items-center justify-center">
            <div className="w-full max-w-7xl relative px-2 md:px-8 md:p-4 2xl:border-x border-dashed border-brand-pale 2xl:h-[calc(100vh-73px)] mt-1 sm:mt-2 lg:pb-0 pt-16 md:pt-0 pb-36">
              {children}
            </div>
          </main>
        </Sidebar>
      </Walkthrough>
      {/* <IntercomChat /> */}
    </>
  )
}
